module.exports = __webpack_public_path__ + "img/cabling.5bd95ae7.webp";